import { render } from "./ExportsReports.vue?vue&type=template&id=1d8b7cd8&ts=true"
import script from "./ExportsReports.vue?vue&type=script&lang=ts"
export * from "./ExportsReports.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__